import type { EdgeTypes } from '@xyflow/react'
import { ConnectorEdge } from './ConnectorEdge'

/** Stable edge-type map. All edges use ConnectorEdge for hover insert / break-link controls. */
export const edgeTypes: EdgeTypes = {
  connector: ConnectorEdge,
}
